<span style="color: red" *ngIf="message">{{ message }}</span>
<ng-container *ngIf="!imgURL">
  <button
    #imageButton
    class="btn btn-outline-gray btn-block btn-mobile d-flex align-items-center justify-content-center bg-white"
    type="button"
    (click)="imageInput.click()"
  >
    <i class="icon-camera text-green fs-28 mr-1"></i> Take photo
  </button>
  <input class="d-none" [attr.rt]="rt" type="file" accept="image/jpeg" (change)="preview($event)" #imageInput />
</ng-container>

<img id="img" [src]="imgURL" class="img-fluid mt-3" *ngIf="imgURL" (load)="imgOnLoad($event)" />
<div class="d-flex" *ngIf="imgURL">
  <a class="text-green cursor-pointer ml-auto" (click)="delete()">Delete photo</a>
</div>
